import Vue from "vue";
import VueGtag from "vue-gtag";
import Cookies from "js-cookie";

import store from "@/store";
import { CookiesConstants, Mutations } from "@/constants";

export const getConstentCookie = () => {
  const consentCookie = Cookies.get(CookiesConstants.consent);

  if (!consentCookie) {
    store.commit(Mutations.setConsent, false);
    return;
  }

  if (consentCookie) {
    store.commit(Mutations.setConsent, true);
    setAnalytics();
    return;
  }
};

export const setConstentCookie = () => {
  const consentCookie = Cookies.get(CookiesConstants.consent);

  if (!consentCookie) {
    store.commit(Mutations.setConsent, true);
    Cookies.set(CookiesConstants.consent, CookiesConstants.consent_value_1, {
      expires: CookiesConstants.consent_expiration
    });
    setAnalytics();
  }
};

const setAnalytics = () => {
  Vue.use(VueGtag, {
    config: { id: store.state.settings.ga_id }
  });
};
